import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("First Name")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Last Name")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Email")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { "scroll-y": false }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"]))
          }, [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "floating" }, {
                              default: _withCtx(() => [
                                _hoisted_1
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: _ctx.first_name,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.first_name) = $event)),
                              required: "",
                              onIonFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errors.first_name = ''))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        (_ctx.errors.first_name)
                          ? (_openBlock(), _createBlock(_component_ion_text, {
                              key: 0,
                              color: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.errors.first_name[0]), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "floating" }, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: _ctx.last_name,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.last_name) = $event)),
                              required: "",
                              onIonFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errors.last_name = ''))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        (_ctx.errors.last_name)
                          ? (_openBlock(), _createBlock(_component_ion_text, {
                              key: 0,
                              color: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.errors.last_name[0]), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "floating" }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: _ctx.userid,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userid) = $event)),
                              type: "email",
                              required: "",
                              onIonFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.errors.userid = '')),
                              onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.onSubmit()), ["enter"]))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        (_ctx.errors.userid)
                          ? (_openBlock(), _createBlock(_component_ion_text, {
                              key: 0,
                              color: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.errors.userid[0]), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                      default: _withCtx(() => [
                        (_ctx.loading)
                          ? (_openBlock(), _createBlock(_component_ion_spinner, {
                              key: 0,
                              color: _ctx.btnColor
                            }, null, 8, ["color"]))
                          : (_openBlock(), _createBlock(_component_ion_button, {
                              key: 1,
                              type: "submit",
                              expand: "block",
                              color: _ctx.btnColor,
                              disabled: _ctx.loading,
                              class: _normalizeClass(['submit-button', { multilines: _ctx.multilines }])
                            }, {
                              default: _withCtx(() => [
                                (_ctx.multilines)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btnText.split('_'), (line, index) => {
                                        return (_openBlock(), _createElementBlock("span", { key: index }, [
                                          _createTextVNode(_toDisplayString(line), 1),
                                          _hoisted_5
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createBlock(_component_ion_text, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.btnText), 1)
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            }, 8, ["color", "disabled", "class"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}